import React from 'react';
import { MarqueeWrapper, MarqueeContent, MarqueeRoot } from './styled';

const Marquee: React.FC<{ insetShadow?: boolean; time?: number; ltr?: boolean }> = ({ children, insetShadow, time, ltr }) => {
  return (
    <MarqueeRoot insetShadow={insetShadow}>
      <MarqueeWrapper>
        <MarqueeContent time={time} ltr={ltr}>
          {children}
        </MarqueeContent>
      </MarqueeWrapper>
    </MarqueeRoot>
  );
};

export default Marquee;
